
import { defineComponent, onBeforeMount, PropType, reactive } from 'vue'

import NewModal from '@/common/new-components/NewModal/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'

import useNotifications from '@/common/composable/useNotifications'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import { Wave } from '@/new-services/types/waves'
import { UpdateWavePayload } from '@/new-services/types/invoice'

import wavesAPI from '@/new-services/waves.service'
import invoicesAPI from '@/new-services/invoice.service'

// @store
import { useNewDispatcherStore } from '@/modules/NewDispatcher/stores/useNewDispatcherStore'

export default defineComponent({
    components: {
        NewModal,
        NewSelect,
    },
    props: {
        invoicesIds: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
    },
    emits: ['cancel', 'submit'],
    setup(props, { emit }) {
        const new_dispatcher_store = useNewDispatcherStore()
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            //
            wave_id: null as number | null,
        })

        const validation$ = useVuelidate(
            {
                wave_id: { required },
            },
            state
        )

        const waves_state = reactive({
            is_loading: false,
            is_failed: false,
            list: [] as Wave[],
        })

        const loadWaves = async () => {
            try {
                waves_state.is_loading = true

                const response = await wavesAPI.getWaves({
                    dispatcherSectorIds: new_dispatcher_store.dispatcherSectorIds,
                })
                waves_state.list = response.data.data

                waves_state.is_failed = false
            } catch (error) {
                console.error(error)
                waves_state.is_failed = true
                notifications.notifyError({
                    error,
                    title: 'При получении списка волн произошла ошибка',
                })
            } finally {
                waves_state.is_loading = false
            }
        }

        const onSubmit = async () => {
            if (state.is_loading) return

            validation$.value.$touch()
            if (validation$.value.$invalid) {
                return
            }

            try {
                state.is_loading = true

                const payload: UpdateWavePayload = {
                    waveId: state.wave_id as number,
                    invoiceIds: props.invoicesIds,
                }

                await invoicesAPI.setWave(payload)

                emit('submit', payload)
                notifications.notify({ type: 'success', title: 'Волна изменена' })
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При смене волны произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        const onCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        onBeforeMount(() => {
            loadWaves()
        })

        //

        return {
            state,
            validation$,
            waves_state,
            //
            loadWaves,
            onSubmit,
            onCancel,
        }
    },
})
